import { graphqlClient } from "../../../client";
import requestPasswordResetExtensionDocument from "./requestPasswordResetExtension.graphql";
import type { Mutations, MutationsRequestPasswordResetExtensionArgs } from "@/core/api/graphql/types";

export async function requestPasswordReset(payload: MutationsRequestPasswordResetExtensionArgs): Promise<boolean> {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "requestPasswordResetExtension">>,
    MutationsRequestPasswordResetExtensionArgs
  >({
    mutation: requestPasswordResetExtensionDocument,
    variables: {
      ...payload,
    },
  });

  return data!.requestPasswordResetExtension;
}
